import { createContext } from "react";
import { WebEditorContextData } from "./types";

export const WebEditorContext = createContext({} as WebEditorContextData);
